import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ControlService {
  time: number;
  timeChange: Subject<number> = new Subject<number>();
  videoVolume: number;
  videoVolumeChange: Subject<number> = new Subject<number>();
  voiceVolume: number;
  voiceVolumeChange: Subject<number> = new Subject<number>();
  videoState: number; // UNSTARTED = -1, ENDED = 0, PLAYING = 1, PAUSED = 2, BUFFERING = 3, CUED = 5
  videoStateChange: Subject<number> = new Subject<number>();
  controlState: number; // opened = 1, closed = 0
  controlStateChange: Subject<number> = new Subject<number>();
  constructor() { }

  updateTime(time: number) {
    this.time = time;
    this.timeChange.next(this.time);
  }

  stop(time: number) {
    this.time = time;
    this.timeChange.next(this.time);
  }

  changeVolume(videoVolume: number) {
    this.videoVolume = videoVolume;
    this.videoVolumeChange.next(this.videoVolume);
  }

  playVideo() {
    this.videoState = 1;
    this.videoStateChange.next(this.videoState);
  }

  pauseVideo() {
    this.videoState = 2;
    this.videoStateChange.next(this.videoState);
  }


  changeVoiceVolume(voiceVolume: number) {
    this.voiceVolume = voiceVolume;
    this.voiceVolumeChange.next(this.voiceVolume);
  }

  updateControlState(state: number){
    this.controlState = state;
    this.controlStateChange.next(this.controlState);
  }
}
